import { colors } from '../colors';
var MuiInputBase = {
  styleOverrides: {
    root: {
      input: {
        height: 'auto'
      },
      '&.Mui-error .MuiInputAdornment-positionStart svg path': {
        fill: colors.NotificacionesRojo,
        backgroundColor: 'rgb(40,40,40)!important'
      }
    }
  }
};
export default {
  MuiInputBase: MuiInputBase
};